import { Breadcrumbs as MuiBreadcrumbs, Box, styled } from "@mui/material";
import { ChevronRight, ArrowBackOutlined, ArrowForwardOutlined } from "@mui/icons-material";
import React from "react";
import { scrollLeftBy, useScrollHelper } from "./useScrollHelper";
export type TBreadcrumb = {
  name: string;
  onClick?: () => void;
};

type BreadcrumbProps = {
  trail: TBreadcrumb[];
};

export const Breadcrumbs = ({ trail }: BreadcrumbProps) => {
  const { onMouseDown, onMouseUp, ref, showLeftArrow, showRightArrow } = useScrollHelper();

  return (
    <BreadcrumbWrapper>
      {showLeftArrow && (
        <ArrowBackOutlined
          onMouseDown={() => onMouseDown("left")}
          onMouseUp={onMouseUp}
          onClick={() => scrollLeftBy(ref, -300)}
        />
      )}

      <StyledBreadcrumb
        aria-label="breadcrumb"
        maxItems={4}
        ref={ref}
        separator={
          <ChevronRight
            sx={{
              fontSize: "23px",
              color: "#999999",
            }}
          />
        }
      >
        {trail.map((item, index) => {
          const isLast = index === trail.length - 1;

          return isLast || !item.onClick ? (
            <TrailItem component="span" key={item.name}>
              {item.name}
            </TrailItem>
          ) : (
            <TrailItem
              key={item.name}
              component="span"
              onClick={item.onClick}
              sx={{ cursor: "pointer" }}
            >
              {item.name}
            </TrailItem>
          );
        })}
      </StyledBreadcrumb>
      {showRightArrow && (
        <ArrowForwardOutlined
          onMouseDown={() => onMouseDown("right")}
          onMouseUp={onMouseUp}
          onClick={() => scrollLeftBy(ref, 300)}
        />
      )}
    </BreadcrumbWrapper>
  );
};
const TrailItem = styled(Box)(({ theme }) => ({
  color: theme.tokens.colors.gray[7],
  fontFamily: "'Nunito', sans-serif",
  fontSize: "16px",
  fontWeight: "500",
  textDecoration: "none",
  minWidth: "max-content",
}));
const StyledBreadcrumb = styled(MuiBreadcrumbs)(({ theme }) => ({
  overflow: "overlay",
  textOverflow: "ellipsis",
  gridColumn: "2",
  width: "100%",
  ol: {
    flexWrap: "nowrap",
  },
  "::-webkit-scrollbar": {
    display: "none",
  },
  li: {
    minWidth: "max-content",
  },
}));
const BreadcrumbWrapper = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "auto 1fr 1rem",
  alignItems: "center",
  paddingRight: "1rem",
  gap: "0.5rem",
  width: "100%",
  height: "100%",
  svg: {
    cursor: "pointer",
    fill: theme.tokens.colors.gray[7],
  },
}));
